/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Publish_All_ButtonInputs */



/**
* | output |
* | --- |
* | "Publish All" |
*
* @param {Iconik_Publish_Publish_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_publish_all_button = /** @type {((inputs?: Iconik_Publish_Publish_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Publish_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier tout")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовать все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて公開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicar tudo")
	return /** @type {LocalizedString} */ ("Publish All")
});